module.exports = __webpack_public_path__ + "img/equip.03778c5a.png";